































import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';

export default defineComponent({
  components: {
    AppIcon,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    maxlength: {
      type: Number,
      default: 100,
    },
    isProducerPage: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isBorderColor = ref(false);
    const searchWords = () => {
      emit('search');
    };

    const clearWords = () => {
      inputValue.value = '';
      emit('clear');
    };

    const inputValue = computed({
      get() {
        return props.value;
      },
      set(value: string) {
        emit('input', value);
      },
    });

    return { searchWords, inputValue, clearWords, isBorderColor };
  },
});
